var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{ref:"ladda",class:_vm.buttonClass,attrs:{"data-style":_vm.dataStyle},on:{"click":_vm.handleClick}},[_vm._t("default",[_c('span',{staticClass:"ladda-label"},[_vm._v("Submit")])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }